<div id="wrapper" class="wrapper clearfix">
    <app-header></app-header>
    <section id="tabs">
        <div class="container pairblank">
            <div class="row">
                <div class="col-sm-12 col-md-12 col-lg-8 mb-30-xs mb-30-sm">
                    <div class="row">
                        <div class="col-sm-12 col-md-12 col-lg-12">
                            <div>
                                <h1 class="info-detail-title" i18n="@@ipoCalendar" ><a [routerLink]="['/ipo-calendar']" title="Halka Arz Takvimi">Halka Arz Takvimi</a></h1>
                            </div>
                            <nav>
                                <ul class="nav-links">
                                    <li routerLinkActive="active-link"><h2 class="header-nav">Halka Arzlar</h2></li>
                                    <li routerLinkActive="active-link"><a [routerLink]="['/ipo-calendar/expected']" title="Halka arz olacak şirketler"><h2 class="header-nav">Beklenen Arzlar</h2></a></li>
                                    <li routerLinkActive="active-link"><a [routerLink]="['/capital-increase']"  title="Sermaye Artırmı Yapacak Hisseler"><h2 class="header-nav">Sermaye Artırmı</h2></a></li>
                                </ul>
                            </nav>
                            <div>
                                <div class="table-responsive">
                                    <table class="table table-striped">
                                        <caption>SPK Onaylı Halka Arz Takvimi</caption>
                                        <thead>
                                            <tr class="ipo-title tables">
                                                <th scope="col"  aria-sort="none" i18n="@@startDate">Başlangıç </th>
                                                <th scope="col"  aria-sort="none" i18n="@@endDate">Bitiş Tarihi</th>
                                                <th scope="col"  aria-sort="none" i18n="@@code">Hisse</th>
                                                <th scope="col"  aria-sort="none" i18n="@@distributionMethod">Dagıtım Şekli</th>
                                                <th scope="col"  aria-sort="none" i18n="@@sharePiece">Pay</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let ipo of ipoList; let i = index; let fst = first; trackBy: trackByFnIpo;" class="tables">
                                                <td  [attr.data-time]="ipo?.startDateString">{{ipo?.startDateString}}</td>
                                                <td  [attr.data-time]="ipo?.startDateString">{{ipo?.endDateString}}</td>
                                                <td  [attr.data-hisse-kodu]="ipo?.code"><a [routerLink]="['/ipo-calendar',ipo?.url]" title="{{ipo?.code}} - {{ipo?.name}} Halka Arzı"style="color: blue;">{{ipo?.code}}</a></td>
                                                <td ><span>{{ipo?.distributionMethod}}</span></td>
                                                <td >{{ipo?.sharePiece | number}}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <div class="row">
                                        <div class="col-sm-12 col-md-12 col-lg-12 clearfix mt-10 text--center">
                                            <app-mansel-pagination [pageIn]="pageInfo" (setManselPaginePageEvent)="setPage($event)"> </app-mansel-pagination>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <app-page-content [name]="'IPO_CONTENT'"></app-page-content>
                </div>
                <div class="col-sm-12 col-md-12 col-lg-4">
                    <app-summary-analysis [imageStatus]="true" [count]="5"></app-summary-analysis>
                    <app-summary-info></app-summary-info>
                    <app-draft-month [toYear]="toYear"></app-draft-month>
                    <app-draft-dividend [toYear]="toYear"></app-draft-dividend>
                </div>
            </div>
        </div>
    </section>
    <app-footer></app-footer>
    <div id="back-to-top" class="backtop"><fa-icon [icon]="faArrUp"></fa-icon></div>
</div>
